import type { FaireProductEntity } from "../../entity_types/product";

export const p_9w4rfrftw6: FaireProductEntity = {
  token: "p_9w4rfrftw6",
  type: "product",
  name: "Mini Glitter Capybara Squishy Squeeze Fidget Kids Toy",
  brandToken: "b_vm4serfd3h",
  brandName: "Label & Decore",
  imageUrl:
    "https://cdn.faire.com/fastly/40941b47cd5183d8511e173cdf656a217e2c3f4066942b536be8482809292239.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/488303179a61fd5ad3cf86fa26b7cfd5df94c8dde37825870a4cffdd42295576.png",
    "https://cdn.faire.com/fastly/8b266d1dc027cbc9c0af4603969bae007b9c4d5367f18509cd9e8b31c404c3df.png",
    "https://cdn.faire.com/fastly/43f91bd7397b1ae3e007efe096efa7935b3d087d0642bcb77869ca47c1967022.png",
    "https://cdn.faire.com/fastly/2d243881c1ef676c77ecd5ad11f19ccad5d5fcb74f8b50aec8533cb7c9269afb.png",
  ],
  priceDollars: 5.25,
  description:
    "Bring the internet's favorite animal right into the palm of your hand with a magical, sparkly twist! Our Mini Glitter Capybara Squishy Squeeze Fidget Toy combines the ultra-trendy, chill vibe of the adorable capybara with an incredibly satisfying, glitter-filled sensory experience. It’s the perfect pocket-sized companion for kids, teens, and adults who love a bit of shimmer with their squish.\n\n🦦 Ultra-Trendy Capybara Design: Modeled after the world's most relaxed animal! Its cute, calm expression and tiny ears bring an instant smile to anyone's face.\n\n✨ Mesmerizing Glitter Magic: Packed with high-quality, vibrant glitter that moves, shifts, and shimmers beautifully inside every single time you squeeze or pinch it.\n\n☁️ Plush, Premium Squeeze: Made from durable, non-toxic materials that provide a soft, dough-like compression. It handles endless stretching, twisting, and mashing, always returning to its original shape.\n\n🎒 Pocket-Sized Peace of Mind: Lightweight and completely portable. Easily slide it into a school backpack, purse, or desk drawer for quick, quiet anxiety relief wherever you go.\n\n🎁 The Perfect Trending Gift: A massive hit for birthday party favors, animal-themed \"Goodie Bags,\" classroom reward bins, or unique holiday stocking stuffers.",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:26.917Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
